import { useQuery } from '@tanstack/react-query';
import { ClockIcon, HashIcon, ServerIcon, WarehouseIcon } from 'lucide-react';

import { DetailList } from '@/components/detail-list';
import { useGateways } from '@/gateways/GatewayProvider';

type Props = {
  locationId?: string;
};

export function WarehouseDetailsSection({ locationId }: Props) {
  const { warehousingGateway } = useGateways();

  const { data: warehouse, isLoading } = useQuery({
    queryKey: ['warehouses', { locationId }],
    queryFn: ({ signal }) => warehousingGateway.getWarehouses(undefined, { signal }),
    select: ({ items }) => items.find((item) => item.locationId === locationId),
    enabled: Boolean(locationId),
  });

  return (
    <DetailList
      title="Warehouse"
      isLoading={isLoading}
      items={
        warehouse || isLoading
          ? [
              { icon: WarehouseIcon, label: 'Name', value: warehouse?.name },
              { icon: HashIcon, label: 'Code', value: warehouse?.code },
              { icon: ServerIcon, label: 'WMS', value: warehouse?.wmsInstanceCode },
              { icon: ClockIcon, label: 'Timezone', value: warehouse?.timezone },
            ]
          : [{ icon: WarehouseIcon, label: 'Status', value: 'No warehouse matched' }]
      }
    />
  );
}
